<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'USUARIOCOMISIONFREELANCE.LBL_INFORMACIONGENERAL' | translate}}" *ngIf="comisionFreelance">
        <div class="grid">
          <label class="lg:col-3 col-3 md:col-4 control-label">{{ 'USUARIOCOMISIONFREELANCE.LBL_USUARIOFREELANCE' | translate }}:</label>
          <label class="lg:col-3 col-3 md:col-8 "><strong>{{comisionFreelance.usuarioSistema}}</strong></label>
          <label class="lg:col-3 col-3 md:col-4 control-label">{{ 'USUARIOCOMISIONFREELANCE.LBL_COMISION' | translate }}:</label>
          <label class="lg:col-3 col-3 md:col-8"><strong>{{comisionFreelance.porcentajeComision}}</strong></label>
          <label class="lg:col-3 col-3 md:col-4 control-label">{{ 'USUARIOCOMISIONFREELANCE.LBL_BASE' | translate }}:</label>
          <label class="lg:col-3 col-3 md:col-8"><strong>{{comisionFreelance.baseFreelance}}</strong></label>
          <label class="lg:col-3 col-3 md:col-4 control-label">{{ 'USUARIOCOMISIONFREELANCE.LBL_HABILITADO' | translate }}:</label>
          <label class="lg:col-3 col-3 md:col-8"><strong>{{comisionFreelance.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' | translate)}}</strong></label>
        </div>
      </p-panel>
    </div>
  </div>
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'USUARIOCOMISIONFREELANCE.LBL_TARIFA' | translate}}">
        <p-table [columns]="colComisionFreelanceTarifas" [value]="comisionFreelanceTarifas" selectionMode="single"
          dataKey="idComisionFreelanceTarifas" [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.rangoInferior | dinero}}</td>
              <td>{{row.rangoSuperior | dinero}}</td>
              <td>{{row.porcentajeAplicado}}</td>
              <td>{{row.porcentajeTarifa}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
  </div>

  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button" pButton
        (click)="regresar()"></button>
    </div>
  </div>
</div>
